<div class="svg-wrap">
    <svg id="towerSunburst" *ngIf="!isModal"></svg>
    <svg id="towerSunburstModal" *ngIf="isModal"></svg>
    <img id="towerSunburstImg" *ngIf="pdfExport">
</div>
<!-- <div id="div_customContent"></div> -->